/**
 * Hashovací algoritmus. Umožňuje proudově počítat hashe dat.
 */
export interface IHashingAlgorithm {
    /**
     * Kód názvu algoritmu
     */
    readonly algorithmName: string;
    /**
     * Zda je počítání hashe dokončeno
     */
    readonly finished: boolean;
    /**
     * Výsledný hash jako pole bytů, dostupný po zavolání metody finish()
     */
    readonly result: BufferSource | null;

    /**
     * Připočítá předaná data k celkovému hashi
     * @param data Data, ze kterých se počítá hash
     */
    update(data: BufferSource): Promise<void>;

    /**
     * Dokončí počítání hashe a připraví výsledek
     */
    finish(): void;
}
